import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function Divider({ text, className }) {
    return (_jsx("div", { className: classNames('flex h-1 w-full justify-center rounded-full bg-white/20', className), children: text ? (_jsx("p", { className: "bg-primary -mt-4 px-2 text-white/60", children: text })) : null }));
}
